module.exports = __webpack_public_path__ + "static/media/nodejs.e87d5cff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/nodejs.png
// module id = 157
// module chunks = 0